<!-- =========================================================================================
  File Name: ClientEditTabSettings.vue
  Description: Client Edit Tab Settings page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.auth-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.button-wrap {
  text-align: right;
}
/*------------06-07-2020------------*/
.event-logo-output {
  height: 200px;
  width: 960px;
  margin: 0 auto;
  border: 1px solid #dfdfdf;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.event-logo-output img {
  width: 100%;
}
.img-delete-butn {
  position: absolute;
  top: 0;
  right: 0;
  background: #e8e8e8;
  padding: 10px 15px;
}
.img-delete-butn button {
  background: transparent;
  border: none;
  cursor: pointer;
}
.event-background-wrap {
  width: 300px;
  height: 200px;
  border: 1px solid #dfdfdf;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  position: relative;
}
.event-bg-wrap {
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.splash-screen-wrapper {
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.single-splash {
  width: 300px;
  height: 200px;
  overflow: hidden;
  border: 1px solid #dfdfdf;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  position: relative;
}
.big-splash {
  height: 480px;
}
.big2-splash {
  height: 350px;
}
.single-splash img {
  width: 100%;
}
.banner-wrap {
  text-align: center;
}
.single-banner {
  width: 100%;
  height: 100px;
  overflow: hidden;
  border: 1px solid #dfdfdf;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  position: relative;
}
.single-banner img {
  width: 100%;
}
.choose-file-area {
  border: 1px solid #dfdfdf;
  padding: 10px;
  width: 400px;
  margin: 0 auto;
  text-align: center;
}
.image-specification {
  margin-top: 15px;
}
.image-specification p strong {
  background: url(../../assets/images/icon_info.png) no-repeat scroll left
    center / 22px;
  display: inline-block;
  padding-left: 26px;
}
.device-name span {
  color: #f00;
}
.banner-single-wrap {
  margin-top: 35px;
}
.single-color-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
/*------------06-07-2020------------*/
</style>
<template>
  <div id="client-edit-tab-settings">
    <vs-tabs position="left">
      <vs-tab label="Login Assets">
        <div class="tab-text">
          <div class="vx-row">
            <div class="vx-col md:w-1-12 w-full mt-5">
              <h4 class="mb-3">Logos &amp; Background Image</h4>
              <p>Upload the logo for the event. Follow the directions for image size &amp; format.</p>
              <br />
              <p>Manage your Background screen from here. If you are creating a new event, and wish that the event will have a splash or welcome screen then please enable it using Yes. You will need to upload new images for each of the sizes mentioned. The Screen (9:16) is a universal size you will provide an image in hi-resolution and we will resize it for different phone sized as applicable.</p>
            </div>
            <div class="vx-col md:w-1-12 w-full">
              <div class="event-logo-output mb-3 mt-3">
                <img
                  v-if="data_local['LoginAssets']['logo']"
                  :src="data_local['LoginAssets']['logo']"
                />
                <span class="img-delete-butn">
                  <button @click="deleteBrandingJsonClient('LoginAssets', 'logo')">
                    <img src="../../assets/images/btn-del.png" />
                  </button>
                </span>
              </div>
              <div class="choose-file-area">
                <input
                  type="file"
                  @change="uploadBrandingJsonClient($event,'960x192', 'LoginAssets', 'logo')"
                  accept="image/*"
                />
                <div class="image-specification">
                  <p>
                    <strong>Image Specification</strong>
                  </p>
                  <p>Supported image formats: jpeg, png and recommended image dimension 960/192</p>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5">
              <div class="event-icon-upload event-bg-wrap">
                <div class="event-background-wrap big-splash my-3">
                  <img
                    v-if="data_local['LoginAssets']['bg2048x2732']"
                    :src="data_local['LoginAssets']['bg2048x2732']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('LoginAssets', 'bg2048x2732')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'2048x2732', 'LoginAssets', 'bg2048x2732')"
                    accept="image/*"
                  />

                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 2048x2732 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5">
              <div class="event-icon-upload event-bg-wrap">
                <div class="event-background-wrap my-3">
                  <img
                    v-if="data_local['LoginAssets']['bg2732x2048']"
                    :src="data_local['LoginAssets']['bg2732x2048']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('LoginAssets', 'bg2732x2048')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'2732x2048', 'LoginAssets', 'bg2732x2048')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 2732x2048 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1-12 w-full mb-5 mt-5">
              <h4 class="mb-3">Color Scheme</h4>
              <p>Choose a theme colour from the available combinations in the drop down. If you do not choose a theme colour, default colour theme will be applied.</p>
              <div class="event-icon-upload">
                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 mt-5">
                    <div class="single-color-bar">
                      <p>Body Text Color</p>
                      <input v-model="data_local['LoginAssets']['bodyTextColor']" type="color" />
                    </div>
                  </div>                  
                </div>
                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 mt-5">
                    <div class="single-color-bar">
                      <p>Login Button Fill Color</p>
                      <input
                        v-model="data_local['LoginAssets']['loginButtonFillColor']"
                        type="color"
                      />
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 mt-5">
                    <div class="single-color-bar">
                      <p>Login Button Text Color</p>
                      <input
                        v-model="data_local['LoginAssets']['loginButtonTextColor']"
                        type="color"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Event List Assets">
        <div class="tab-text">
          <div class="vx-row">
            <div class="vx-col md:w-1-12 w-full mb-5 mt-5">
              <h4 class="mb-3">Color Scheme</h4>
              <p>Choose a theme colour from the available combinations in the drop down. If you do not choose a theme colour, default colour theme will be applied.</p>
              <div class="event-icon-upload">
                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 mt-5">
                    <div class="single-color-bar">
                      <p>Body Text Color</p>
                      <input v-model="data_local['EventListAssets']['bodyTextColor']" type="color" />
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 mt-5">
                    <div class="single-color-bar">
                      <p>TopBar Color</p>
                      <input v-model="data_local['EventListAssets']['topBar']" type="color" />
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 mt-5">
                    <div class="single-color-bar">
                      <p>FontBar Color</p>
                      <input v-model="data_local['EventListAssets']['fontBar']" type="color" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1-12 w-full mt-5">
              <h4 class="mb-3">Banner Image</h4>
              <p>You need to upload all images or go for all images as set</p>
            </div>
            <div class="vx-col md:w-1/2 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    iPhone 5
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner640x88']"
                    :src="data_local['EventListAssets']['banner640x88']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner640x88')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'640x88', 'EventListAssets', 'banner640x88')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 640x88 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    iPhone 6
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner750x103']"
                    :src="data_local['EventListAssets']['banner750x103']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner750x103')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'750x103', 'EventListAssets', 'banner750x103')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 750x103 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    iPhone 10
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner1125x156']"
                    :src="data_local['EventListAssets']['banner1125x156']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner1125x156')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'1125x156', 'EventListAssets', 'banner1125x156')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 1125x156 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    iPhone 6+
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner1242x171']"
                    :src="data_local['EventListAssets']['banner1242x171']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner1242x171')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'1242x171', 'EventListAssets', 'banner1242x171')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 1242x171 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1-12 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    All Android Phone
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner1440x176']"
                    :src="data_local['EventListAssets']['banner1440x176']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner1440x176')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'1440x176', 'EventListAssets', 'banner1440x176')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 1440x176 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1-12 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    iPad landscape
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner2732x88']"
                    :src="data_local['EventListAssets']['banner2732x88']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner2732x88')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'2732x88', 'EventListAssets', 'banner2732x88')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 2732x88 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1-12 w-full banner-single-wrap">
              <div class="event-icon-upload banner-wrap">
                <p class="device-name">
                  <strong>
                    iPad Portrait
                    <span>*</span>
                  </strong>
                </p>
                <div class="single-banner">
                  <img
                    v-if="data_local['EventListAssets']['banner2048x88']"
                    :src="data_local['EventListAssets']['banner2048x88']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'banner2048x88')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'2048x88', 'EventListAssets', 'banner2048x88')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 2048x88 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5">
              <div class="event-icon-upload event-bg-wrap">
                <div class="event-background-wrap big-splash my-3">
                  <img
                    v-if="data_local['EventListAssets']['bg2048x2732']"
                    :src="data_local['EventListAssets']['bg2048x2732']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'bg2048x2732')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'2048x2732', 'EventListAssets', 'bg2048x2732')"
                    accept="image/*"
                  />

                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 2048x2732 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5">
              <div class="event-icon-upload event-bg-wrap">
                <div class="event-background-wrap my-3">
                  <img
                    v-if="data_local['EventListAssets']['bg2732x2048']"
                    :src="data_local['EventListAssets']['bg2732x2048']"
                  />
                  <span class="img-delete-butn">
                    <button @click="deleteBrandingJsonClient('EventListAssets', 'bg2732x2048')">
                      <img src="../../assets/images/btn-del.png" />
                    </button>
                  </span>
                </div>
                <div class="choose-file-area">
                  <input
                    type="file"
                    @change="uploadBrandingJsonClient($event,'2732x2048', 'EventListAssets', 'bg2732x2048')"
                    accept="image/*"
                  />
                  <div class="image-specification">
                    <p>
                      <strong>Image Specification</strong>
                    </p>
                    <p>Dimension: (Width x Height) 2732x2048 pixels; Format:JPG/PNG 72DPI</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <div class="vx-col md:w-1-12 w-full mt-5 button-wrap">
      <vs-button class="mr-3 mb-2" @click="save_changes">Save</vs-button>
    </div>
  </div>
</template>
<script>
var vm;
export default {
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
    };
  },

  methods: {
    deleteBrandingJsonClient(filesrc, filename) {
      if (confirm("Image will be deleted!")) {
        let clientId = this.$route.params.clientId;
        this.$vs.loading();
        this.$store
          .dispatch("clientManagement/deleteBrandingJsonClient", {
            filename: filename,
            updateField: filesrc,
            clientId: clientId,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Branding",
              text: "Deleted with image size: " + filename,
            });
            this.data_local[filesrc][filename] = "";
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }
    },
    uploadBrandingJsonClient(input, fileWH, filesrc, filename) {
      //console.log(filename + filesrc)
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = file.size / 1024;
        if(FileSize > 750)
        {
          alert("Uploaded file size exceeds 750 KB");
          return false;
        }

        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            vm.uploadFile(file, filename, filesrc);
          } else {
            alert("File dimension does not match " + fileWH);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadFile(file, filename, filesrc) {
      let clientId = this.$route.params.clientId;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.data_local[filesrc][filename] = e.target.result;
      };
      reader.readAsDataURL(file);
      this.$vs.loading();
      this.$store
        .dispatch("clientManagement/uploadBrandingJsonClient", {
          file: file,
          filename: filename,
          updateField: filesrc,
          clientId: clientId,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "Updated with image size: " + filename,
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            //this.$router.push('/event/list');
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    save_changes() {
      let clientId = this.$route.params.clientId;
      this.$vs.loading();
      this.$store
        .dispatch("clientManagement/uploadBrandingJsonClientColor", {
          data: this.data_local,
          clientId: clientId,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "JSON updated",
          });
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    vm = this;
  },
}
</script>